export const successRegisterOfflineEventNoticeId = 'successRegisterOfflineEventNoticeId'
export const successRegisterOnlineNotStartedEventNoticeId =
  'successRegisterOnlineNotStartedEventNoticeId'
export const successRegisterOnlineStartedEventNoticeId =
  'successRegisterOnlineStartedEventNoticeId'
